import { AnyAction } from "redux";
import { LOGOUT_SUCCESS } from "../types/auth";
import { SET_EXPIRING_MANDATE_STATUS, SET_LOGGED_IN_PORTFOLIO_FILTER, SET_LOGGED_IN_PORTFOLIO_HELDAWAY_STATUS, SET_LOGGED_IN_PORTFOLIO_LIST, SET_LOGGED_IN_SELECTED_PORTFOLIO_OBJECT, SET_PORTFOLIO_FILTER, SET_PORTFOLIO_HELDAWAY_STATUS, SET_PORTFOLIO_LIST, SET_SELECTED_PORTFOLIO_OBJECT } from "../types/portfolioFilter";
import { VERIFY_OTP_PAYMENT_SUCCESS } from "../types/onBoarding";

export interface selectedPortfolioType {
    selectedPortfolio: { label: string, value: string };
    portfolioList: Array<{ label: string, value: string }>;
    isPortfolioHeldaway: boolean
    selectedPortfolioObj: Record<string, any>
    isExpiringMandate: boolean
    // Sticky copy of the logged-in investor's portfolio context.
    // `selectedPortfolio` / `selectedPortfolioObj` / `portfolioList` /
    // `isPortfolioHeldaway` get overwritten when the user opens another
    // investor via the Family flow; these "loggedIn" variants do not. The
    // sidebar uses them so that asset-class navigations always carry the
    // logged-in user's portfolio context (incl. their portfolio dropdown
    // options and held-away status).
    loggedInSelectedPortfolio: { label: string, value: string };
    loggedInSelectedPortfolioObj: Record<string, any>;
    loggedInPortfolioList: Array<{ label: string, value: string }>;
    loggedInIsPortfolioHeldaway: boolean;
}

const initState = {
    selectedPortfolio: {
        label: '',
        value: ''
    },
    portfolioList: [],
    isPortfolioHeldaway: false,
    selectedPortfolioObj: {},
    isExpiringMandate: false,
    loggedInSelectedPortfolio: {
        label: '',
        value: ''
    },
    loggedInSelectedPortfolioObj: {},
    loggedInPortfolioList: [],
    loggedInIsPortfolioHeldaway: false,
}

export default function portfolioReducer(state = initState, action: AnyAction): Partial<selectedPortfolioType> {
    switch (action.type) {
        case VERIFY_OTP_PAYMENT_SUCCESS: {
            return {
                ...state,
                selectedPortfolio: action?.body?.portfolioId ?? ""
            }
        }
        case SET_PORTFOLIO_FILTER: {
            // console.log("action", action);
            return {
                ...state,
                selectedPortfolio: action.payload
            };
        }
        case SET_PORTFOLIO_LIST: {
            // console.log("action", action);
            return {
                ...state,
                portfolioList: action.payload
            };
        }
        case SET_PORTFOLIO_HELDAWAY_STATUS: {
            return {
                ...state,
                isPortfolioHeldaway: action.payload
            };
        }
        case SET_SELECTED_PORTFOLIO_OBJECT: {
            return {
                ...state,
                selectedPortfolioObj: action.payload
            };
        }

        case SET_EXPIRING_MANDATE_STATUS: {
            return {
                ...state,
                isExpiringMandate: action.payload
            };
        }
        case SET_LOGGED_IN_PORTFOLIO_FILTER: {
            return {
                ...state,
                loggedInSelectedPortfolio: action.payload
            };
        }
        case SET_LOGGED_IN_SELECTED_PORTFOLIO_OBJECT: {
            return {
                ...state,
                loggedInSelectedPortfolioObj: action.payload
            };
        }
        case SET_LOGGED_IN_PORTFOLIO_LIST: {
            return {
                ...state,
                loggedInPortfolioList: action.payload
            };
        }
        case SET_LOGGED_IN_PORTFOLIO_HELDAWAY_STATUS: {
            return {
                ...state,
                loggedInIsPortfolioHeldaway: action.payload
            };
        }
        case LOGOUT_SUCCESS: {
            return {
                ...initState,
            };
        }

        default:
            return state;
    }
}